"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { toast } from "react-toastify";
import AddNewPost from "@/app/components/CMS/add-new";
import { isLoggedIn, fetchUser } from "@/app/funcs/api";
import { canEditArticle } from "@/app/funcs/articleEditPermissions";
import SectionGridList from "../SectionGridList";

export default function ArticlesList() {
  const searchParams = useSearchParams();
  const router = useRouter();
  const [showAddNew, setShowAddNew] = useState(false);
  const [userLoggedIn, setUserLoggedIn] = useState(false);
  const [currentUser, setCurrentUser] = useState(null);
  const [editPostId, setEditPostId] = useState(null);

  useEffect(() => {
    setUserLoggedIn(!!isLoggedIn());
    if (isLoggedIn()) {
      fetchUser()
        .then(setCurrentUser)
        .catch(() => setCurrentUser(null));
    } else {
      setCurrentUser(null);
    }
  }, []);

  useEffect(() => {
    const raw = searchParams.get("edit");
    const id = raw ? parseInt(raw, 10) : NaN;
    if (Number.isFinite(id) && id > 0) {
      setEditPostId(id);
      setShowAddNew(true);
    }
  }, [searchParams]);

  const handleAddNewClick = () => {
    if (!userLoggedIn) {
      toast.error("لابد ان تسجل الدخول لتتمكن من المشاركة");
      return;
    }
    setEditPostId(null);
    setShowAddNew((v) => !v);
    router.replace("/sections/articles");
  };

  const handleCancelEdit = () => {
    setEditPostId(null);
    router.replace("/sections/articles");
    setShowAddNew(false);
  };

  const cardFooter = (item) => {
    if (!currentUser || !canEditArticle(currentUser, item.author)) return null;
    return (
      <div
        className="mt-2 position-relative"
        style={{ zIndex: 2 }}
        onClick={(e) => e.stopPropagation()}
        onPointerDown={(e) => e.stopPropagation()}
      >
        {/* Same flow as ArticleEditLink: URL ?edit= drives showAddNew + editPostId (avoids in-card clicks being lost). */}
        <Link
          href={`/sections/articles?edit=${item.id}`}
          className="btn btn-sm btn-outline-dark"
          scroll
          prefetch={false}
        >
          <i className="bi bi-pencil-square me-1" aria-hidden />
          تحرير
        </Link>
      </div>
    );
  };

  return (
    <SectionGridList
      postType="posts"
      pageTitle="المقالات"
      description="اقرأ أحدث المقالات والنصائح العملية في تجربة المستخدم وواجهة المستخدم."
      hrefBase="/sections/articles"
      searchPlaceholder="ابحث عن مقال..."
      emptyMessage="لا يوجد مقالات متاحة حالياً."
      fallbackIcon="bi-file-earmark-text"
      imageMaxHeight="220px"
      imageFit="cover"
      cardFooter={cardFooter}
      titleActions={
        <button
          type="button"
          className="btn btn-dark"
          onClick={handleAddNewClick}
          title="إضافة مقال جديد"
        >
          <i className="bi bi-plus-lg" aria-hidden /> أضف مشاركتك الآن 😊
        </button>
      }
      belowTitle={
        showAddNew ? (
          <AddNewPost
            postTypes={["posts"]}
            editPostId={editPostId}
            onCancelEdit={handleCancelEdit}
            onSuccess={
              editPostId
                ? () => {
                    setEditPostId(null);
                    setShowAddNew(false);
                    router.replace("/sections/articles");
                  }
                : undefined
            }
          />
        ) : null
      }
    />
  );
}
